import React, {
  Ref,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { InputFields } from "components/common";
import { fields } from "./config";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Tooltip,
  Typography,
} from "antd";
import {
  convertIosStringToDate,
  convertIosStringToDateDayjs,
  convertIosStringToDateObjectDayjs,
  formatToCurrencyTypeFloor,
} from "helper/common";
import "./SurgeryDetail.scss";
import residentialNurseService from "api/residentialNurse";
import Notification from "components/common/notification/notification";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { fontOptions } from "pages/Electrocardiography/tabs/DetailDiagnose/ElectrocardiographyInfo/TextEditor";
import { valueType } from "antd/es/statistic/utils";
import { useAppDispatch } from "redux/hooks";
import {
  setIsChangetab,
  setListDmPPPT,
  setOptionsIcd,
} from "redux/reducer/residentialNurse";
import { listExamination } from "api";
import dayjs from "dayjs";

export type propsRef = {
  getFormValue: () => any;
};

type Props = {
  allSurgeryDetailInfo?: any;
  infoPatient: any;
  ppPhauThuat?: string;
  ref?: Ref<propsRef>;
};

const SurgeryDetail = React.forwardRef<propsRef, Props>((props, ref) => {
  const { allSurgeryDetailInfo, infoPatient } = props;

  const surgeryDetailInfo = allSurgeryDetailInfo?.quaTrinhPhauThuat;

  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSurgeryTemp, setLoadingSurgeryTemp] = useState(false);
  const [optionsCatalog, setOptionsCatalog] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [editorState, setEditorState] = useState(null);

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      const rawValues = form.getFieldsValue();
      const newValue = {
        ...rawValues,
        moTa: editorState
          ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
          : "",
      };

      return newValue;
    },
  }));

  const onEditorStateChange = useCallback((editorState) => {
    setEditorState(editorState);
  }, []);
  const dispatch = useAppDispatch();
  const fetchListDmPPPT = async () => {
    const params = {
      idNhomDichVu: 2,
    };
    try {
      const response = await listExamination.getByIdNDV(params);
      const options = response.data.map((e) => ({
        value: e.id,
        label: e.tenDichVu,
      }));
      dispatch(setListDmPPPT(options));
      fields.find((e) => e.name === "ppPhauThuat").options = options;
    } catch (err) {
      Notification("error", "Lấy dữ liệu phương pháp phẫu không thành công");
    }
  };
  const [listSurgeryStaff, setListSurgeryStaff] = useState<any>([]);
  const getLitSurgeryStaff = async () => {
    try {
      const res = await residentialNurseService.getLitSurgeryStaff();
      setListSurgeryStaff(
        res.find((it) => it.name === "bacSiPhauThuat") ?? null
      );
    } catch (err) {}
  };
  useEffect(() => {
    fetchListDmPPPT();
  }, []);
  // Lấy danh sách ICd
  const getDiagnoseBeforeSurgery = async () => {
    setLoading(true);
    try {
      const res = await residentialNurseService.getDiagnoseBeforeSurgery();
      const options = res.map((item) => {
        return { value: item.tenIcd, label: item.maIcd } || [];
      });
      const options2 = res.map((item) => {
        return { label: item.tenIcd, value: item.maIcd } || [];
      });
      dispatch(setOptionsIcd(options));
      fields.find((e) => e.name === "chuanDoanSauPTList").options = options;

      fields.find((e) => e.name === "chuanDoanSauPTList").onChange = (
        e,
        options
      ) => {
        form.setFieldValue("chuanDoanSauPTValue", options.value);
      };
      fields.find((e) => e.name === "chuanDoanSauPTValue").options = options2;

      fields.find((e) => e.name === "chuanDoanSauPTValue").onChange = (
        e,
        options
      ) => {
        form.setFieldValue("chuanDoanSauPTList", options.value);
      };

      fields.find((e) => e.name === "chanDoanTruocPTList").options = options;
      fields.find((e) => e.name === "chanDoanTruocPTList").onChange = (
        e,
        options
      ) => {
        // const value = form.getFieldValue("chanDoanTruocPTList");

        form.setFieldValue("chanDoanTruocPTValue", options.value);
      };

      fields.find((e) => e.name === "chanDoanTruocPTValue").options = options2;
      fields.find((e) => e.name === "chanDoanTruocPTValue").onChange = (
        e,
        options
      ) => {
        // const value = form.getFieldValue("chanDoanTruocPTValue");

        form.setFieldValue("chanDoanTruocPTList", options.value);
      };
      setLoading(false);
    } catch (error) {
      setLoading(false);

      Notification("error", "Đã xảy ra lỗi khi lấy danh sách icd");
    }
  };

  // Lấy danh sách mẫu phẫu thuật
  const getListCatalog = async () => {
    setLoadingSurgeryTemp(true);
    const params = {
      page: 1,
      limit: 100000,
    };
    try {
      const res = await residentialNurseService.getListCatalog(params);

      const options = res.data.map((item) => {
        return { value: item.id, label: item.tenMau } || [];
      });

      setSelectedOption(res.data);

      setOptionsCatalog(options || []);

      setLoadingSurgeryTemp(false);
    } catch (error) {
      setLoadingSurgeryTemp(false);

      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy danh sách mẫu trình tự phẫu thuật"
      );
    }
  };
  const getListLoaiTTT = async () => {
    try {
      const res = await residentialNurseService.getListLoaiTTT();

      const options = res.data
        .sort((a, b) => b?.soLuongTon - a?.soLuongTon)
        .map((item) => {
          return (
            {
              value: item.id,
              label:
                item.tenTheoThuongMai +
                " - " +
                formatToCurrencyTypeFloor(item.donGiaNhap) +
                (item.bidDecision && item.bidDecision?.bidCode
                  ? ` - ${item.bidDecision?.bidCode}`
                  : ""),
              disabled: item.soLuongTon <= 0 ? true : false,
            } || []
          );
        });
      fields.find((e) => e.name === "ttNhanTao").options = options;
    } catch (error) {
      console.log("🚀 ~ getListLoaiTTT ~ error:", error);
      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy danh sách loại thủy tinh thể nhân tạo"
      );
    }
  };

  const handleChangeSurgeryTemp = async (value: valueType) => {
    const selectedData = await selectedOption.find(
      (item: any) => item.id === value
    );

    const blockFromHTMl = await convertFromHTML(selectedData?.moTa);
    const state = await ContentState.createFromBlockArray(
      blockFromHTMl.contentBlocks,
      blockFromHTMl.entityMap
    );
    setEditorState(EditorState.createWithContent(state));
  };

  useEffect(() => {
    setEditorState(null);
    if (surgeryDetailInfo) {
      form.setFieldsValue({
        ...surgeryDetailInfo,
        thoiGianBatDau: convertIosStringToDateObjectDayjs(
          surgeryDetailInfo?.thoiGianBatDau
        ),
        thoiGianKetThuc: convertIosStringToDateObjectDayjs(
          surgeryDetailInfo?.thoiGianKetThuc
        ),

        mauPT: surgeryDetailInfo?.mauPT ?? null,
      });

      if (surgeryDetailInfo?.moTa) {
        const blockFromHTMl = convertFromHTML(surgeryDetailInfo?.moTa);
        const state = ContentState.createFromBlockArray(
          blockFromHTMl.contentBlocks,
          blockFromHTMl.entityMap
        );
        setEditorState(EditorState.createWithContent(state));
      } else setEditorState(null);
    } else form.resetFields();
    getDiagnoseBeforeSurgery();
    getListLoaiTTT();
    getListCatalog();
    setChecked(surgeryDetailInfo?.isChecked);
  }, [surgeryDetailInfo]);

  useEffect(() => {
    const parseBBhoiCHan = JSON.parse(
      JSON.parse(infoPatient?.bienBanHoiChan ?? null)
    );

    const parseredData =
      parseBBhoiCHan && parseBBhoiCHan[parseBBhoiCHan?.length - 1]?.data;

    if (parseredData) {
      form.setFieldsValue({
        ppVoCam: parseredData?.phuongPhapVoCam,
        ppPhauThuat:
          surgeryDetailInfo?.quaTrinhPhauThuat?.ppPhauThuat ??
          parseredData?.phuongPhapPhauThuat,
      });
    }
    if (surgeryDetailInfo?.chanDoanTruocPTList) {
      form.setFieldValue(
        "chanDoanTruocPTList",
        surgeryDetailInfo?.chanDoanTruocPTList
      );
    } else {
      form.setFieldValue("chanDoanTruocPTList", infoPatient?.icdChanDoan);
    }
    if (surgeryDetailInfo?.chanDoanTruocPTValue) {
      form.setFieldValue(
        "chanDoanTruocPTValue",
        surgeryDetailInfo?.chanDoanTruocPTValue
      );
    } else {
      form.setFieldValue("chanDoanTruocPTValue", infoPatient?.chanDoan);
    }
  }, [infoPatient]);

  const time = [5, 8, 10, 15, 20, 25, 30];
  const handleClick = (e) => {
    //tách giá trị đầu vào bỏ dấu + chỉ lấy số
    const validValue = Number(e.target.innerText.split("+")[1]);
    const startTIme = form.getFieldValue("thoiGianBatDau");
    //đổi định dạng
    const currentTime = dayjs(startTIme);
    //cộngt số phút vào hàmd
    const newTime = currentTime.add(validValue, "minute").toISOString();
    //set lại giá trị
    form.setFieldValue("thoiGianKetThuc", convertIosStringToDateDayjs(newTime));
  };
  const handleChange = (e) => {
    if (e) {
      dispatch(setIsChangetab(true));
    }
  };
  return (
    <div className="staff-surgery">
      <Form form={form} onValuesChange={handleChange}>
        <Row gutter={[16, 8]}>
          <InputFields data={fields} />
          <Col xl={24} md={24}>
            <Row>
              <Col span={4}>Thời gian phẫu thuật</Col>
              <Col span={20}>
                <Row justify={"space-between"}>
                  {time.map((e, i) => (
                    <Button onClick={handleClick} style={{ width: 100 }}>
                      +{e}
                    </Button>
                  ))}
                </Row>
              </Col>
            </Row>
          </Col>
          <Col xl={24} md={24}>
            <Form.Item
              label={
                <Row gutter={[16, 8]}>
                  <Form.Item name={"isChecked"}>
                    <Checkbox
                      checked={checked}
                      onChange={(e) => {
                        form.setFieldsValue({ isChecked: e.target.checked });
                        setChecked(e.target.checked);
                      }}
                    />
                    <Tooltip arrow={false} placement="top" title={"Biến chứng"}>
                      <Typography.Text ellipsis={true}>
                        Biến chứng
                      </Typography.Text>
                    </Tooltip>
                  </Form.Item>
                </Row>
              }
              labelAlign="left"
              labelCol={{ xl: 4, md: 6 }}
              wrapperCol={{ xl: 20, md: 18 }}
              name={!checked ? null : "bienChung"}
            >
              <Input disabled={!checked} />
            </Form.Item>
          </Col>
          <Col xl={24} md={24}>
            <Form.Item
              label={
                <Tooltip arrow={false} placement="top" title={"Ghi chú"}>
                  <Typography.Text ellipsis={true}>Ghi chú</Typography.Text>
                </Tooltip>
              }
              labelAlign="left"
              labelCol={{ xl: 4, md: 6 }}
              wrapperCol={{ xl: 20, md: 18 }}
              name="ghiChu"
            >
              <Input placeholder="'Nhập" />
            </Form.Item>
          </Col>
          <Col xl={24} md={24}>
            <Form.Item
              labelAlign="left"
              name="mauPT"
              label={
                <Tooltip arrow={false} placement="top" title={"Ghi chú"}>
                  <Typography.Text ellipsis={true}>
                    Mẫu trình tự PT
                  </Typography.Text>
                </Tooltip>
              }
              labelCol={{ xl: 4, md: 6 }}
              wrapperCol={{ xl: 20, md: 18 }}
            >
              <Select
                loading={loadingSurgeryTemp}
                showSearch
                style={{
                  width: "100%",
                }}
                filterOption={(input, option) =>
                  (option?.label.toString().toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
                placeholder={"Chọn"}
                options={optionsCatalog}
                allowClear={true}
                onChange={handleChangeSurgeryTemp}
              />
            </Form.Item>
          </Col>
          <Col xl={24} className="editor">
            <Form.Item
              label="Mô tả"
              name={"moTa"}
              labelCol={{ xl: 4, md: 6 }}
              wrapperCol={{ xl: 20, md: 18 }}
              labelAlign="left"
            >
              <Editor
                editorState={editorState}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={onEditorStateChange}
                toolbar={fontOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
});

export default SurgeryDetail;
